module.exports = __webpack_public_path__ + "media/hyper/images/bg-pattern-dark-474bb337d6aa6700d9532b5c35646030.png";